var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileWrapper',[_c('OrdersList',{class:[ _vm.hasMargin ? 'mt-5' : '']})],1)}
var staticRenderFns = []

export { render, staticRenderFns }